"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmailUpdate;
var _react = _interopRequireWildcard(require("react"));
var _awsAmplify = require("aws-amplify");
var _reactRouterDom = require("react-router-dom");
var _ForgotPasswordOtpComponent = _interopRequireDefault(require("../components/ForgotPasswordOtpComponent"));
var _reactRedux = require("react-redux");
var _index = _interopRequireDefault(require("../common_features/assets/index"));
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _Services = require("../common_features/utility/Services");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function EmailUpdate() {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const {
    email
  } = userInfo;
  const [otpValue, setOtpValue] = (0, _react.useState)('');
  const [openErrorModal, setopenErrorModal] = (0, _react.useState)(false);
  const [resendCodeClick, setResendCodeClicked] = (0, _react.useState)(true);
  const [invalidOtp, setInvalidOtp] = (0, _react.useState)(false);
  const [id, setId] = (0, _react.useState)('');
  function onOtpChange(val) {
    setOtpValue(val);
  }
  function resendDisabled() {
    return resendCodeClick || false;
  }
  function checkDisabled() {
    return otpValue.length === 6 || false;
  }
  const userId = async () => {
    let user = await _awsAmplify.Auth.currentAuthenticatedUser();
    let userPoolId = user.pool.userPoolId;
    let authUsername = user.username;
    let USERID = "".concat(userPoolId, "#").concat(authUsername);
    setId(USERID);
  };
  (0, _react.useEffect)(() => {
    userId();
  }, []);
  function onClickResetButton() {
    _awsAmplify.Auth.verifyCurrentUserAttributeSubmit('email', otpValue).then(data => {
      setIsLoading(false);
      (0, _Services.reSyncVerify)(id).then(response => {
        navigate(_RoutePath.default.admin.path);
      });
    }).catch(err => {
      setIsLoading(false);
      if (err.message === "Invalid verification code provided, please try again.") {
        setInvalidOtp(true);
      } else if (err.message === "Attempt limit exceeded, please try after some time.") {
        setopenErrorModal(true);
      }
    });
  }
  const onClickResendCode = () => {
    setResendCodeClicked(false);
    if (email) {
      setIsLoading(true);
      _awsAmplify.Auth.verifyCurrentUserAttribute("email").then(data => {
        setIsLoading(false);
        setOtpValue('');
        setInvalidOtp(false);
      }).catch(err => {
        setIsLoading(false);
        if (err.message === "Attempt limit exceeded, please try after some time.") {
          setopenErrorModal(true);
        }
      });
    }
  };
  const onOkPress = () => {
    navigate(_RoutePath.default.login.path);
  };
  const handleBack = () => {
    navigate(-1);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ForgotPasswordOtpComponent.default, {
    headerText: 'Sign In',
    handleBack: handleBack,
    variant: "warning-modal",
    displayModal: openErrorModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalDetailTextFail: "You have exceeded your attempt. Try after sometime.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Ok",
    positiveAction: onOkPress,
    forgotPasswordHeaderText: "Check Your Email",
    forgotPasswordDetailText: "We've sent you an email with a 6-digit code. Please check your email and enter the code below.",
    resendCodeButtonText: "Re-Send Code",
    headerPentairLogo: _index.default.pentairLogo.default,
    otpValue: otpValue,
    onChnageOtp: onOtpChange,
    otpCount: 6,
    resetButtonText: "Submit",
    onClickReset: onClickResetButton,
    onClickResendCode: onClickResendCode,
    isLoading: isLoading,
    isSuccessModal: true,
    resendCodePressed: resendCodeClick,
    resendDisabled: resendDisabled(),
    onComplete: () => setResendCodeClicked(true),
    invalidOtp: invalidOtp,
    isFromEmailUpdate: true,
    isDisabled: checkDisabled()
  }));
}